import {
  FoldersDocument,
  UpdateFolderDocument,
  UpdateFolderMutation,
  UpdateFolderMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateFolder = () => {
  const [updateFolderMutation, { loading }] = useMutation(UpdateFolderDocument, {
    extractorFn: (data: UpdateFolderMutation) => data.documentsMutations.updateDocumentsFolder,
  })

  return {
    loading,
    updateFolder(variables: UpdateFolderMutationVariables) {
      return updateFolderMutation({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [{ query: FoldersDocument, variables: { ids: [variables.id] } }],
      })
    },
  }
}
